"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePaletteToCssVars = void 0;
var _react = require("react");
var _cdsCommon = require("@cbhq/cds-common");
var _palette = require("../utils/palette");
const usePaletteToCssVars = () => {
  const paletteConfig = (0, _cdsCommon.usePaletteConfig)();
  return (0, _react.useMemo)(() => (0, _palette.setPaletteConfigToCssVars)(paletteConfig), [paletteConfig]);
};
exports.usePaletteToCssVars = usePaletteToCssVars;